import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './MobileMenu.css';

function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button
        className="hamburger-button"
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <span className={`hamburger-line ${isOpen ? 'open' : ''}`}></span>
        <span className={`hamburger-line ${isOpen ? 'open' : ''}`}></span>
        <span className={`hamburger-line ${isOpen ? 'open' : ''}`}></span>
      </button>

      {isOpen && (
        <>
          <div className="menu-overlay" onClick={closeMenu}></div>
          <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
            <Link to="/" className="mobile-menu-item" onClick={closeMenu}>
              Home
            </Link>
          </div>
        </>
      )}
    </>
  );
}

export default MobileMenu;
